import { cn } from '@heroui/react'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

export const MentionList = forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const selectItem = (index) => {
    const item = props.items[index]
    if (item) {
      props.command({ id: item.user_id, label: `${item.first_name} ${item.last_name}` })
    }
  }

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length)
  }

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length)
  }

  const enterHandler = () => {
    selectItem(selectedIndex)
  }

  useEffect(() => setSelectedIndex(0), [props.items])

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        downHandler()
        return true
      }

      if (event.key === 'Enter') {
        enterHandler()
        return true
      }

      return false
    },
  }))

  return (
    <div className={`
      z-50 min-w-[200px] overflow-hidden rounded-md border border-gray-200
      bg-white shadow-lg
    `}
    >
      {props.items.length
        ? (
            props.items.map((item, index) => (
              <button
                type="button"
                className={cn(
                  'flex w-full items-center gap-2 px-3 py-2 text-left text-sm',
                  'hover:bg-gray-100',
                  index === selectedIndex && 'bg-gray-100',
                )}
                key={item.id}
                onClick={() => selectItem(index)}
              >
                <div className={`
                  flex size-7 items-center justify-center rounded-full
                  bg-gradient-to-br from-blue-400 to-purple-600 text-xs
                  font-medium text-white
                `}
                >
                  {(item.first_name || item.last_name || '?').charAt(0).toUpperCase()}
                </div>
                <div className="flex-1">
                  <div className="font-medium">
                    {item.first_name}
                    {' '}
                    {item.last_name}
                  </div>
                  {item.member_email && (
                    <div className="text-xs text-gray-500">{item.member_email}</div>
                  )}
                </div>
              </button>
            ))
          )
        : (
            <div className="px-3 py-2 text-sm text-gray-500">No users found</div>
          )}
    </div>
  )
})

MentionList.displayName = 'MentionList'
